import {
  readLabelInfo,
} from "@/store/performance/getters";
import {
  dispatchGetPerfAvgdData,
  dispatchGetPerfSecondData,
  dispatchChangeFPSlte,
  dispatchChangeFPSgte,
} from "@/store/performance/actions";
import { store } from "@/store";
import * as echarts from "echarts";
import {allChart} from './mixins.js'

//标签相关功能
const useLabels = {
  data() {
    return {
      lableList: [],
    }
  },

  methods: {
    getLableInfo() {
      // this.lableList.forEach(v=>v.id_label=readLabelInfo(store).filter(v=>v.id_label!='all').forEach(v=>v.id_label))
      let lableList1 = readLabelInfo(store).filter(
        (v) => v.id_label != "all" && v.is_group === false
      );
      // this.lableList=lableList1
      // this.lableList.forEach(function(v,index){
      //   this.lableColrorList.forEach(function(j,i){
      //       if(index==i){
      //         v.color=j
      //       }
      //   })
      // })

      let labelWidthAll = [];

      let labelWidth = this.chartDataResult.rows.timeline.length;
      this.chartDataResult.rows.label.forEach(function (v) {
        labelWidthAll.push((v.length / labelWidth) * 100 + "%");
      });

      // function arrCheck(arr) {
      //   var newArr = [];
      //   for (let i = 0; i < arr.length; i++) {
      //     let temp = arr[i];
      //     let count = 0;
      //     for (let j = 0; j < arr.length; j++) {
      //       if (arr[j] == temp) {
      //         count++;
      //         arr[j] = -1;
      //       }
      //     }
      //     if (temp != -1) {
      //       newArr.push(count);
      //     }
      //   }
      //   return newArr;
      // }
      // let b=[]
      // let widthList = JSON.parse(
      //   JSON.stringify(this.chartDataResult.rows.label)
      // );
      // let c = this.chartDataResult.rows.label.length - 1;
      // arrCheck(widthList).forEach(function (v) {
      //
      //   b.push((v / c) * 100 + "%");
      // });
      //

      //
      // arrCheck(widthList);
      for (let index in lableList1) {
        this.lableList3.push({
          id_label: lableList1[index].id_label,
          color: this.lableColorList[index],
          width: labelWidthAll[index],
        });
      }

      for (let i = 0; i < this.lableList3.length; i++) {
        if (this.lableList3[i].width == undefined) {
          this.lableList3[i].width = 0;
        }
      }

      this.lableList = this.lableList3;
      let req1 = RegExp(/_G_Battle/);
      let arr15 = JSON.parse(JSON.stringify(this.lableList));
      for (let i = 0; i < arr15.length; i++) {
        if (req1.test(arr15[i].id_label)) {
          arr15[i].id_label = arr15[i].id_label.replace("_G_Battle", "");
        }
      }
      this.lableList = arr15;
    },

    async handleSelect(value, row) {
      this.selectedRow = value
      this.loading = true;
      this.loading1 = true;
      let arr3 = [];
      this.multipleSelection = value;
      //
      this.startValue = 0;
      this.endValue = 100;
      this.chartSettings.dataZoom[0].start = this.startValue;
      this.chartSettings.dataZoom[0].end = this.endValue;
      this.start_thread = 0;
      this.end_thread = 100;
      //

      let tableArr = [];
      let timeList = [];
      let tableSolt = [];
      let tableArr1 = [];
      //

      this.multipleSelection
        .filter((v) => v.id_label !== "all")
        .forEach(function (v) {
          tableArr.push(v.id_label);
        });

      // 排序
      this.testInfoList.forEach(function (v) {
        tableSolt.push(v.id_label);
      });

      tableSolt.forEach(function (v, i) {
        tableArr.forEach(function (j, k) {
          if (v === j) {
            tableArr1.push(v);
          }
        });
      });

      this.lteValue = "10";
      this.gteValue = "25";

      if (row.id_label === "all") {
        if (value.includes(row)) {
          this.$refs.dataTable.toggleAllSelection();
          this.lableShow = true;
          await dispatchGetPerfAvgdData(store, {
            project: this.project_id,
            id_test: this.id_test,
            id_label: ["all"],
          });
          await dispatchChangeFPSlte(store, {
            project: this.project_id,
            id_test: this.id_test,
            value: 10,
            labels: ["all"],
            mode: "lte",
          });
          await dispatchChangeFPSgte(store, {
            project: this.project_id,
            id_test: this.id_test,
            value: 25,
            labels: ["all"],
            mode: "gte",
          });
          await this.getTestInfo();
          await this.getLabelInfo();
          await this.getPerfInfo();
          await this.getperNewInfo();

          await this.getChangeFPS();
          await this.getFPSValue(this.testInfo3);
          await this.getOverview2(this.testInfo2, this.testInfo3, true);
          await this.getCPUValue(this.testInfo3);
          await this.getMemoryValue(this.testInfo3);
          await this.getGPUValue(this.testInfo3);
          await this.getNetWorkValue(this.testInfo3);
          await this.getCsWitch(this.testInfo3);
          await this.getWakeups(this.testInfo3);
          await this.getCustom(this.testInfo3);
          this.loading1 = false;
          await dispatchGetPerfSecondData(store, {
            project: this.project_id,
            id_test: this.id_test,
            id_label: ["all"],
          });

          this.lableList = this.lableList3;
        } else {
          this.$refs.dataTable.clearSelection();
          this.selectedRow = []
          this.lableShow = false;
          await dispatchGetPerfAvgdData(store, {
            project: this.project_id,
            id_test: this.id_test,
            id_label: [],
          });
          await dispatchChangeFPSlte(store, {
            project: this.project_id,
            id_test: this.id_test,
            value: 10,
            labels: "",
            mode: "lte",
          });
          await dispatchChangeFPSgte(store, {
            project: this.project_id,
            id_test: this.id_test,
            value: 25,
            labels: "",
            mode: "gte",
          });
          await this.getTestInfo();
          await this.getLabelInfo();
          await this.getPerfInfo();
          await this.getperNewInfo();
          await this.getChangeFPS();
          await this.getFPSValue(this.testInfo3);
          await this.getOverview2(this.testInfo2, this.testInfo3, true);
          await this.getCPUValue(this.testInfo3);
          await this.getMemoryValue(this.testInfo3);
          await this.getGPUValue(this.testInfo3);
          await this.getNetWorkValue(this.testInfo3);
          await this.getCsWitch(this.testInfo3);
          await this.getWakeups(this.testInfo3);
          await this.getCustom(this.testInfo3);
          this.loading1 = false;
          await dispatchGetPerfSecondData(store, {
            project: this.project_id,
            id_test: this.id_test,
            id_label: [],
          });
        }
      } else {
        this.lableList3.forEach(function (v) {
          tableArr.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        this.lableShow = true;
        this.allselecitonList = tableArr1;

        await dispatchGetPerfAvgdData(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: tableArr1.join('|'),
        });
        await dispatchChangeFPSlte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: 10,
          labels: tableArr1.join('|'),
          mode: "lte",
        });
        await dispatchChangeFPSgte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: 25,
          labels: tableArr1.join('|'),
          mode: "gte",
        });
        await this.getTestInfo();
        await this.getLabelInfo();
        await this.getPerfInfo();
        await this.getChangeFPS();
        await this.getperNewInfo();
        await this.getFPSValue(this.testInfo3);
        await this.getOverview2(this.testInfo2, this.testInfo3, true);
        await this.getCPUValue(this.testInfo3);
        await this.getMemoryValue(this.testInfo3);
        await this.getGPUValue(this.testInfo3);
        await this.getNetWorkValue(this.testInfo3);
        await this.getCsWitch(this.testInfo3);
        await this.getWakeups(this.testInfo3);
        await this.getCustom(this.testInfo3);
        this.loading1 = false;
        await dispatchGetPerfSecondData(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: tableArr1.join('|'),
        });
      }
      //  await this.getTestInfo();
      // await this.getLabelInfo();
      // await this.getPerfInfo();
      // await this.getChangeFPS();
      // await this.getFPSValue(this.testInfo);
      await this.getperNewInfo();
      await this.getData();
      //
      // function arrCheck(arr) {
      //   var newArr = [];
      //   for (let i = 0; i < arr.length; i++) {
      //     let temp = arr[i];
      //     let count = 0;
      //     for (let j = 0; j < arr.length; j++) {
      //       if (arr[j] == temp) {
      //         count++;
      //         arr[j] = -1;
      //       }
      //     }
      //     if (temp != -1) {
      //       newArr.push(count);
      //     }
      //   }
      //   return newArr;
      // }
      let labelWidthAll1 = [];

      let labelWidth1 = this.chartDataResult.rows.timeline.length;
      this.chartDataResult.rows.label.forEach(function (v) {
        labelWidthAll1.push((v.length / labelWidth1) * 100 + "%");
      });

      // let b = [];
      // let widthList = JSON.parse(
      //   JSON.stringify(this.chartDataResult.rows.label)
      // );
      // let c = this.chartDataResult.rows.label.length - 1;
      // arrCheck(widthList).forEach(function (v) {
      //
      //   b.push((v / c) * 100 + "%");
      // });
      //

      arr3.forEach(function (v, i) {
        labelWidthAll1.forEach(function (j, index) {
          if (i == index) {
            v.width = j;
          }
        });
      });

      for (let i = 0; i < arr3.length; i++) {
        if (arr3[i].width == undefined) {
          arr3[i].width = 0;
        }
      }
      if (row.id_label === "all") {
        this.lableList = this.lableList3;
      } else {
        this.lableList = arr3;
      }
      let req1 = RegExp(/_G_Battle/);
      let arr15 = JSON.parse(JSON.stringify(this.lableList));
      for (let i = 0; i < arr15.length; i++) {
        if (req1.test(arr15[i].id_label)) {
          arr15[i].id_label = arr15[i].id_label.replace("_G_Battle", "");
        }
      }
      this.lableList = arr15;
      // arrCheck(widthList);
      await this.fps_series();
      if (this.project_id == 59) {
        await this.custom_series();
        await this.custom_series_second();
      }
      await this.cpu_usage_line_series();
      await this.electric_line_series();
      await this.cpu_usage_normalized_series();
      await this.temp_line_series();
      await this.pss_line_series();
      await this.gpu_memory_counter_series();
      await this.flow_line_series();
      await this.frametime_line_series();
      await this.gpu_general_counter_series();
      await this.gpu_shader_counter_series();
      await this.wakeups_data_series();
      await this.cswitch_data_series();
      await this.memory_detail_series();
      await this.cpu_freq_line_series();
      await this.cpu_core_usage_series();
      await this.cpu_clock_series();
      await this.analyse_series();
      this.getlableShow();
      this.drawPieChartFPS();
      this.drawPieChartFrameTime();
      this.drawPieChartCPUUsage();
      this.drawPieChartCPUFreq();
      this.drawPieChartPSS();
      this.drawPieChartMemoryDetail();
      this.drawPieChartGPUGeneralCounter();
      this.drawPieChartGPUMemoryCounter();
      this.drawPieChartGPUShaderCounter();
      this.drawPieChartFlow();
      this.drawAnalyseTrend();
      if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        this.drawPieChartCsWitch();
        this.drawPieChartWakeups();
      }
      if (this.chartDatacustom?.rows?.i?.length !== 0) {
        this.drawPieChartMonomem();
        this.drawPieChartVerts();
        this.drawPieChartTris();
        this.drawPieChartDc();
        this.drawPieChartGc();
      }
      if (this.project_id == 59) {
        if (this.chartDataCstom?.rows.timeline?.length !== 0) {
          this.drawPieChartcustom();
          this.drawPieChartcustomSecond();
          this.drawChartCustom()
        }
      }
      if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        this.drawPieChartMono();
      }
      if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        this.drawPieChartDrawCall();
      }
      if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        this.drawPieChartTriangle();
      }
      if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        this.drawPieChartTemp();
      }
      if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        this.drawPieChartElectric();
      }
      // this.getFPSValue(this.testInfo3);
      //  this.getOverview2(this.testInfo2,this.testInfo3,true);
      // this.getCPUValue(this.testInfo3);
      // this.getMemoryValue(this.testInfo3);
      // this.getGPUValue(this.testInfo3);
      // this.getNetWorkValue(this.testInfo3);
      // this.getCustom(this.testInfo3);
      this.getPictureData();
      this.drawPieChartCPUUsageNormalized();
      this.drawPieChartCPUCoreUsage();
      this.drawPieChartCPUClock();
      this.changeCustomFields()

      this.loading = false;
    },

    drawPieChartElectric() {
      let electric_line = document.getElementById("electric_line");

      if (electric_line.getAttribute("style") === "display:none") {
        electric_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(electric_line);

      let ElectricLineChart = echarts.init(electric_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      ElectricLineChart.on("datazoom", async (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = ElectricLineChart.getModel().option.dataZoom[0].startValue;
        let end = ElectricLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        await this.drawMarkLines();
        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        // //   this.drawPieChartElectric();
        // // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.electric_line_chart = ElectricLineChart
      ElectricLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (ElectricLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = ElectricLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = ElectricLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataElectric.rows.timeline;
          const xAxisValue = xaxis[xIndex]

          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawMarkLines(xAxisValue);
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }
          if (this.project_id == 59) {
            if (this.chartDataCstom?.rows.timeline?.length !== 0) {
              this.drawPieChartcustom();
              this.drawPieChartcustomSecond()
            }
          }
          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "手机电量",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataElectric.rows.timeline,
        },
        series: this.electric_line_data,
      };
      ElectricLineChart.setOption(option);
      this.judgNull(option.series, electric_line);
      // this.judgNull(option.series, electric_line);
      // this.judgZero(option.series, electric_line);
      // if (
      //   document.getElementById("temp_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("electric_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("temp_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return ElectricLineChart;
    },

    drawPieChartCPUUsage() {
      let cpu_usage_line = document.getElementById("cpu_usage_line");
      if (cpu_usage_line.getAttribute("style") === "display:none") {
        cpu_usage_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_usage_line);

      let CPUUsageLineChart = echarts.init(cpu_usage_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUUsageLineChart.on("datazoom", async (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUUsageLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUUsageLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      let xaxis = this.chartDataResult.rows.timeline;

      allChart.cpu_usage_line_chart = CPUUsageLineChart
      this.onChartClick(CPUUsageLineChart, xaxis)
      let option;

      option = {
        title: {
          text: "CPU Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_usage_line_data,
      };
      CPUUsageLineChart.setOption(option);
      this.judgNull(option.series, cpu_usage_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUUsageLineChart;
    },

    drawPieChartCPUUsageNormalized() {
      let cpu_usage_line = document.getElementById("cpu_usage_normalized");
      if (cpu_usage_line.getAttribute("style") === "display:none") {
        cpu_usage_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_usage_line);

      let CPUUsageLineChart = echarts.init(cpu_usage_line);
      
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUUsageLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUUsageLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUUsageLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        // this.drawPieChartFPS();
        // this.drawAnalyseTrend();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.cpu_usage_normalized_chart = CPUUsageLineChart
      this.onChartClick(CPUUsageLineChart, this.chartDataResult.rows.timeline)

      let option;

      option = {
        title: {
          text: "CPU Usage(Normalized)",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_usage_normalized_data,
      };
      CPUUsageLineChart.setOption(option);
      this.judgNull(option.series, cpu_usage_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUUsageLineChart;
    },

    drawPieChartCPUFreq() {
      let cpu_freq_line = document.getElementById("cpu_freq_line");
      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
      
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;
        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
    
      allChart.cpu_freq_line_chart = CPUFreqLineChart
      this.onChartClick(CPUFreqLineChart, this.chartDataResult.rows.timeline)
      let option;

      option = {
        title: {
          text: "CPU Core USage(Normalized)",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_freq_line_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },

    drawPieChartCPUCoreUsage() {
      let cpu_freq_line = document.getElementById("cpu_core_usage");
      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
     
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.cpu_core_usage_chart = CPUFreqLineChart
      this.onChartClick(CPUFreqLineChart, this.chartDataResult.rows.timeline)

      let option;

      option = {
        title: {
          text: "CPU Core USage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_core_usage_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },

    drawPieChartCPUClock() {
      let cpu_freq_line = document.getElementById("cpu_clock");

      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
      
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.cpu_clock_chart = CPUFreqLineChart
      this.onChartClick(CPUFreqLineChart, this.chartDataResult.rows.timeline)

      let option;

      option = {
        title: {
          text: "CPU Clock",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_clock_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },

    drawPieChartPSS() {
      let pss_line = document.getElementById("pss_line");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.pss_line_chart = PSSLineChart
      this.onChartClick(PSSLineChart, this.chartDataResult.rows.timeline)

      option = {
        title: {
          text: "Memory Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.pss_line_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartMemoryDetail() {
      let pss_line = document.getElementById("memory_detail");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.memory_detail_chart = PSSLineChart
      this.onChartClick(PSSLineChart, this.chartDataResult.rows.timeline)
      // let all_series = [];
      // this.memory_detail.forEach((item, index) => {
      //   if (index == 0) {
      //     all_series.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //       markLine: {
      //         symbol: ["circle", "arrow"],
      //         data: [
      //           {
      //             silent: true,
      //             xAxis: this.month_new,
      //             label: {
      //               position: "end",
      //               show: true,
      //               formatter: this.month_new,
      //               color: "ED5664",
      //             },
      //             lineStyle: {
      //               type: "solid",
      //               color: "#ED5664",
      //               width: "1",
      //               opacity: this.opacity, // 设置为0，使标记线不可见
      //             },
      //           },
      //         ],
      //       },
      //     });
      //   } else {
      //     all_series.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //     });
      //   }
      // });
      option = {
        title: {
          text: "MemoryDetail",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: {
          ...this.chartSettings.tooltip,
          position: function (point, params, dom, rect, size) {
            return [point[0] + 20, 0]
          },
          //extraCssText: 'max-height: 300px;overflow: scroll'
        },
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.memory_detail_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartGPUGeneralCounter() {
      let pss_line = document.getElementById("gpu_general_counter");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.gpu_general_counter_chart = PSSLineChart
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          const xAxisValue = xaxis[xIndex]

          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawMarkLines(xAxisValue);
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }
          if (this.project_id == 59) {
            if (this.chartDataCstom?.rows.timeline?.length !== 0) {
              this.drawPieChartcustom();
              this.drawPieChartcustomSecond()
            }
          }
          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU General Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_general_counter_data,
      };

      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartGPUMemoryCounter() {
      let pss_line = document.getElementById("gpu_memory_counter");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.gpu_memory_counter_chart = PSSLineChart
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          const xAxisValue = xaxis[xIndex]

          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawMarkLines(xAxisValue);
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }
          if (this.project_id == 59) {
            if (this.chartDataCstom?.rows.timeline?.length !== 0) {
              this.drawPieChartcustom();
              this.drawPieChartcustomSecond()
            }
          }
          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU Memory Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        timeline: this.chartSettings.timeline,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_memory_counter_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartFlow() {
      let pss_line = document.getElementById("flow_line");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.flow_line_chart = PSSLineChart
      this.onChartClick(PSSLineChart, this.chartDataResult.rows.timeline)

      option = {
        title: {
          text: "Network",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.flow_line_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartCsWitch() {
      let pss_line = document.getElementById("cswitch");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
     
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   // this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.cswitch_chart = PSSLineChart
      this.onChartClick(PSSLineChart, this.chartDataResult.rows.timeline)

      option = {
        title: {
          text: "CSwitch",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataSec.rows.timeline,
        },
        series: this.cswitch_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartWakeups() {
      let pss_line = document.getElementById("wakeups");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   // this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.wakeups_chart = PSSLineChart
      this.onChartClick(PSSLineChart, this.chartDataSec.rows.timeline)

      option = {
        title: {
          text: "Wakeups",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataSec.rows.timeline,
        },
        series: this.wakeups_data,
      };
      PSSLineChart.setOption(option);

      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartGPUShaderCounter() {
      let pss_line = document.getElementById("gpu_shader_counter");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });

      allChart.gpu_shader_counter_chart = PSSLineChart
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          const xAxisValue = xaxis[xIndex]

          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawMarkLines(xAxisValue);
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }
          if (this.project_id == 59) {
            if (this.chartDataCstom?.rows.timeline?.length !== 0) {
              this.drawPieChartcustom();
              this.drawPieChartcustomSecond()
            }
          }
          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU Shader Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_shader_counter_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartTemp() {
      let temp_line = document.getElementById("temp_line");
      if (temp_line.getAttribute("style") === "display:none") {
        temp_line.setAttribute("style", "width: 100%; height: 400px");
      }
      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(temp_line);

      let TempLineChart = echarts.init(temp_line);
      
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      TempLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = TempLineChart.getModel().option.dataZoom[0].startValue;
        let end = TempLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        // this.drawPieChartFPS();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        // //   this.drawPieChartTemp();
        // // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawAnalyseTrend();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      allChart.temp_line_chart = TempLineChart
      this.onChartClick(TempLineChart, this.chartDataTemp.rows.timeline)

      let option;
      let series = this.temp_line_data;

      option = {
        title: {
          text: "手机温度",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataTemp.rows.timeline,
        },
        series: series,
      };

      TempLineChart.setOption(option);
      this.judgNull(option.series, temp_line);
      // this.judgNull(option.series, temp_line);
      // if (
      //   document.getElementById("temp_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("electric_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("temp_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return TempLineChart;
    },
  }
}

export {useLabels}